import { parseAsJson, useQueryStates } from 'nuqs';

export type DataGridUrlFilterState = Record<string, unknown>;

export type DataGridUrlSortState = {
  colId: string;
  sort: 'asc' | 'desc' | null;
  sortIndex: number | null;
}[];

function parseFilterState(value: unknown): DataGridUrlFilterState | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  return value as DataGridUrlFilterState;
}

function parseSortState(value: unknown): DataGridUrlSortState | null {
  if (!Array.isArray(value)) return null;

  const sortState = value.filter((item): item is DataGridUrlSortState[number] => {
    return !!item && typeof item === 'object' && typeof (item as { colId?: unknown }).colId === 'string';
  });

  return sortState.length ? sortState : null;
}

const dataGridUrlStateParsers = {
  filter: parseAsJson(parseFilterState),
  sort: parseAsJson(parseSortState),
};

export function useDataGridUrlState() {
  return useQueryStates(dataGridUrlStateParsers, { history: 'push' });
}
